import { useEffect, useMemo, useRef } from 'react';
import throttle from 'lodash.throttle';
export const useThrottledCallback = ({ callback, waitTimeMs = 1000, trailing = false }) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = callback;
    }, [callback]);
    const debouncedCallback = useMemo(() => {
        const func = () => {
            ref.current?.();
        };
        return throttle(func, waitTimeMs, { trailing });
    }, [waitTimeMs, trailing]);
    return debouncedCallback;
};
